import React, { memo } from 'react'

import { classnames, CubeCheck, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, elementType, node, number, shape, string } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'

function Media({
  previewUrl = undefined,
  alt,
  variationType = undefined,
  isMain = false,
  isCover = false,
  position = null,
  children,
}) {
  return (
    <>
      {previewUrl && (
        <img
          className={classnames('variation-card__image', isCover && 'variation-card__image--cover')}
          src={previewUrl}
          alt={alt}
        />
      )}
      {variationType && (
        <span className="variation-card__type cgt-caption-semibold">
          <Icon notSpaced svgComponent={variationType.icon} color="dark" size={iconSize} />
          {variationType.label}
        </span>
      )}
      {isMain && (
        <span className="variation-card__main-badge" aria-label="Main variation">
          <Icon notSpaced svgComponent={CubeCheck} color="dark" size={iconSize} />
        </span>
      )}
      {position != null && <span className="variation-card__position">{position}</span>}
      {children}
    </>
  )
}

Media.propTypes = {
  previewUrl: string,
  alt: string.isRequired,
  variationType: shape({
    icon: elementType,
    label: string,
  }),
  isMain: bool,
  isCover: bool,
  position: number,
  children: node.isRequired,
}

export default memo(Media)
